import React from 'react';
import { Link } from 'react-router-dom';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';

export class QuickViewError extends React.Component {
  render() {
    return (
      <section id='QuickViewDisplay'>
        <div className='row'>
          <div className='col-sm-12'>
            <button className='close btn-tertiary' type='button' onClick={this.props.passedAppFunctions.closeQuickView}>
              <CloseXIcon />
            </button>
            <div id='error-message' className='alert alert-danger qvError--message' role='alert'>
              An error occured attempting to quick view this item.{' '}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default QuickViewError;
